<app-loader [isLoading]="isLoading"></app-loader>

@if(!isMobileView){
  <div class="modal-heading">
    <h2 class="modal-title">Manage user</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  
<div class="modal-container">

  <div class="d-flex hello align-items-center">
    <div class="profile-pic">
      <img src="../../../../../assets/images/profilePic.png" alt="" height="120px" width="120px" />
    </div>

    <div class="greet d-flex flex-column" (click)="openUserDetailsDialog()">
      <span class="greet-name cursor-pointer">{{ userData.name }}</span>
      <div>
        <span class="greet-role cursor-pointer">{{ userData.role }}</span>
      </div>
    </div>
  </div>

  <form [formGroup]="userForm" class="form-container">
    <div class="d-flex flex-column" style="gap: 20px">
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> User Status</span>
          <span class="active-text" [ngClass]="data.userDetails.status == 'Inactive'? 'warn-status' : ''">{{ data.userDetails.status }}</span>
        </div>
        <div>
          <label class="switch">
            <input
              type="checkbox"
              [checked]="statusActive"
              formControlName="userStatus"
              (change)="onStatusToggle($event)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> Privilege</span>
          <span class="active-text" [ngClass]="data.userDetails.privilege == 'Blocked' ? 'warn-status' : ''">{{ data.userDetails.privilege }}</span>
        </div>
        <div [hidden]="!this.data.isSuperUser">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="userPrivilege"
              formControlName="userPrivilege"
              (change)="onPrivilegeToggle($event)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> Permission Level</span>
        </div>
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select
              class="custom-mat-select custom-select"
              id="permissionLevel"
              placeholder="Permission Level"
              [(value)]="userData.showPermissionLevel"
            >
              <mat-option *ngFor="let level of levels; let i = index" [value]="level" (click)="onSelectLevel(level)">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  @if(selectedLevel) {
    <div>
      <div
        class="dp-table-scroll"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        >
          <dp-table
            [dataTable]="roleLocationData"
            [displayedColumns]="displayColumnData"
            [componentMap]="cellComponentMap"
            (cellClick)="onManageUserCellClick($event, '')"
          ></dp-table>
      </div>

      <div class="btn-container d-flex justify-content-end">
        <button class="dp-secondary-btn btn-div" (click)="openNewRoleDialog()">
        Add New Area
        </button>
      </div>

    </div>
  } @else {

  }
  </div>

} @else {
  <div class="modal-heading">
    <h2 class="modal-title">Manage user</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  
<div class="modal-container">

  <div class="d-flex hello align-items-center">
    <div class="profile-pic">
      <img src="../../../../../assets/images/profilePic.png" alt="" height="120px" width="120px" />
    </div>

    <div class="greet d-flex flex-column">
      <div class="greet-name">{{ userData.name }}</div>
      <div>
        <span class="greet-role">{{ userData.role }}</span>
      </div>
    </div>
  </div>

  <form [formGroup]="userForm" class="form-container">
    <div class="d-flex flex-column" style="gap: 20px">
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> User Status</span>
          <span class="active-text" [ngClass]="data.userDetails.status == 'Inactive'? 'warn-status' : ''">{{ data.userDetails.status }}</span>
        </div>
        <div>
          <label class="switch">
            <input
              type="checkbox"
              [checked]="statusActive"
              formControlName="userStatus"
              (change)="onStatusToggle($event)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> Privilege</span>
          <span class="active-text" [ngClass]="this.userPrivilege ? 'warn-status' : ''">{{ this.data.userDetails.privilege }}</span>
        </div>
        <div [hidden]="!this.data.isSuperUser">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="this.userPrivilege"
              formControlName="userPrivilege"
              (change)="onPrivilegeToggle($event)"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="user-details-div d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span class="user-status-text"> Permission Level</span>
        </div>
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select
              class="custom-mat-select custom-select"
              id="state"
              placeholder="Permission"
            >
              <mat-option *ngFor="let level of levels; let i = index" [value]="level" (click)="onSelectLevel(level)">
                {{ level }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  @if(selectedLevel) {
    <div class="scroll-container" >
      @if(roleLocationData.length !== 0){ @for( lists of roleLocationData; track lists){
        <ul class="eachdataList">
          <li class="data">
            Counrty<span>{{ lists.country ? lists.country : "-" }}</span>
          </li>
          <li class="data">
            State
            <span>{{ lists.state ? lists.state : "-" }}</span>
          </li>
          <li class="data">
            District
            <span>{{ lists.district ? lists.district : "-" }}</span>
          </li>
        
          <li class="data">
            Role
            <span>{{ lists.role ? lists.role : "-" }}</span>
          </li>
          <li class="data">
            Status
            <span>{{ lists.status ? lists.status : "-" }}</span>
          </li>
         
          <div class="d-flex align-items-center btn-gap justify-content-between">
            <button
              class="manage-user-btn dp-secondary-btn view-btn"
              (click)="openPermissionDialog(lists)"
            >
              Permissions
            </button>
          </div>
       
        </ul>
        }}
        <div class="btn-container d-flex justify-content-end">
          <button class="dp-secondary-btn btn-div" (click)="openNewRoleDialog()">
          Add New Area
          </button>
        </div>
      </div>
     
  }
 
  </div>
}
